// Core

// Chakra
import {
  Box, Code, Table, Tbody, Td,
  Text, Tr,
} from '@chakra-ui/react';

// Components
import {
  GiveawaysActiveIcon,
} from 'components/Icons/Icons';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import Card from 'components/Card/Card';
import ErrorCard from 'components/Errors';
import { parseDateTime } from '../../../../services/Utils';

const RequestLogDetailsContent = ({ requestLog, errorCard }) => {

  return (
    <Box
      zIndex="9"
      position="relative"
    >
      <Breadcrumbs
        icon={GiveawaysActiveIcon}
        target="Reuest Logs"
        url="#/request-logs"
        current="Reuest Log"
        variant="standart"
      />

      {errorCard && <ErrorCard error={errorCard} maxW="840px" />}

      <Box maxW="840px">

        <Text variant="title-lg" mt="40px" mb="14px">
          Request Log Details
        </Text>

        <Card padding="24px" mb="40px">

          <Table>
            <Tbody>
              <Tr>
                <Td
                  verticalAlign="top"
                  border="unset"

                >
                  <Text variant="title">Created At</Text>
                </Td>
                <Td verticalAlign="top" border="unset">
                  {parseDateTime(requestLog.createdAt)}
                </Td>
              </Tr>
              <Tr>
                <Td
                  verticalAlign="top"
                  border="unset"

                >
                  <Text variant="title">ID</Text>
                </Td>
                <Td verticalAlign="top" border="unset">
                  {requestLog.id}
                </Td>
              </Tr>
              <Tr>
                <Td
                  verticalAlign="top"
                  border="unset"

                >
                  <Text variant="title">Hostname</Text>
                </Td>
                <Td verticalAlign="top" border="unset">
                  {requestLog?.hostname}
                </Td>
              </Tr>
              <Tr>
                <Td
                  verticalAlign="top"
                  border="unset"

                >
                  <Text variant="title">Forwarded For</Text>
                </Td>
                <Td verticalAlign="top" border="unset">
                  {requestLog?.forwardedFor}
                </Td>
              </Tr>
              <Tr>
                <Td
                  verticalAlign="top"
                  border="unset"

                >
                  <Text variant="title">IP</Text>
                </Td>
                <Td verticalAlign="top" border="unset">
                  {requestLog?.ip}
                </Td>
              </Tr>
              <Tr>
                <Td
                  verticalAlign="top"
                  border="unset"

                >
                  <Text variant="title">Original Url</Text>
                </Td>
                <Td verticalAlign="top" border="unset">
                  {requestLog?.originalUrl}
                </Td>
              </Tr>
              <Tr>
                <Td
                  verticalAlign="top"
                  border="unset"

                >
                  <Text variant="title">Path</Text>
                </Td>
                <Td verticalAlign="top" border="unset">
                  {requestLog?.path}
                </Td>
              </Tr>
              <Tr>
                <Td
                  verticalAlign="top"
                  border="unset"

                >
                  <Text variant="title">User Agent</Text>
                </Td>
                <Td verticalAlign="top" border="unset">
                  {requestLog?.userAgent}
                </Td>
              </Tr>

            </Tbody>
          </Table>
        </Card>

        <Text variant="title-lg" mt="40px" mb="14px">
          Query Params
        </Text>

        <Card padding="24px" mb="40px">
          <Code
            p={4}
            w="100%"
            mt="24px"
            whiteSpace="pre"
            overflowX="auto"
            colorScheme="gray"
          >
            {JSON.stringify(requestLog?.queryParams, null, 2)}
          </Code>
        </Card>

        <Text variant="title-lg" mt="40px" mb="14px">
          Body
        </Text>

        <Card padding="24px" mb="40px">

          <Code
            p={4}
            w="100%"
            mt="24px"
            whiteSpace="pre"
            overflowX="auto"
            colorScheme="gray"
          >
            {JSON.stringify(requestLog?.body, null, 2)}
          </Code>
        </Card>

      </Box>

    </Box>
  );
};

export default RequestLogDetailsContent;
